import React from "react";
import { Modal as CoreModal } from "@jelly/ui";

import styles from "./Modal.module.scss";

export const Modal: React.FC<React.ComponentProps<typeof CoreModal>> = (props) => {
  return <CoreModal {...props} style={styles} />;
};

//TODO: override X button style
// TODO: add ability to close modal on escape keyboard button press
